module.exports = __webpack_public_path__ + "img/img6.cdee422d.svg";